<template>
    <div class="tenantTnc__main-container">
        <div class="tenantTnc__text-container">
            <div class="mainTitle_container">
                <p>{{title}}</p>
            </div>
            <div class="text_container" id="tenantTncText">
                <div v-html="templateData" class="subText__container" :class="isEndUser ? '' : 'addWidth'"></div>
            </div>
            <div class="main_footer_container" v-if="isEndUser">
                <v-checkbox color="#638AFF" v-model="agreeTncCheckBox" :label="'I agree to the terms of the Constella ' + title"></v-checkbox>
                <div class="sub_footer_container">
                    <p @click="downloadFile()" class="download"><v-icon class="mr-1">icon-download_file</v-icon>Download</p>
                    <div class="actionButtons">
                        <v-btn class="cancel" @click="cancelTnc()">Cancel</v-btn>
                        <v-btn class="agree" @click="agreeTnc()" :class="agreeTncCheckBox ? 'enable' : 'disable'">I AGREE</v-btn>
                    </div>
                </div>
            </div>
            <div class="main_footer_container buttons mt-5" v-else>
                <v-btn class="commonButton" @click="backToLogin()" >Back to Login</v-btn>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
export default {
    name: 'tenantTnc',
    props: {
        session: {
            type: String
        },
        isEndUser: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            agreeTncCheckBox: false,
            templateData: "",
            title: "",
            availableAgreements: {
                'eula': 'EULA',
                'evaluation': 'EVALUATION AGREEMENT'
            }
        }
    },
    created() {
        var self = this;
        Vue.http.get('/tenant_terms_and_conditions/', {
        params:{
            'tenantSchemaName': sessionStorage.getItem('tenantSchemaName'),
            'tenantName': sessionStorage.getItem('tenantName'),
            'isEndUser': self.isEndUser
        }
        }).then((res)=>{
            try {
                let data = JSON.parse(res.data);
                let agreement = data.agreement;
                self.templateData = self.dataContent(data.content);
                if (self.isEndUser) {
                    self.title =  self.availableAgreements[agreement];
                } else {
                    self.title = ""
                }
                
            } catch (err){
                // Must be an issue with response data type -->>
                console.log(err);
                self.templateData = res.data.content;
            }
        },(error)=>{
            console.log("Error", error);
            window.location = '/logout';
        });
    },
    methods: {
        dataContent(content) {
            if (content && (typeof content ==='string' || content instanceof String)){
                return content;
            }
            else{
                return JSON.stringify(content);
            }
        },
        backToLogin() {
            window.location = '/logout';
        },
        cancelTnc() {
            var self = this;
            self.$emit('getTenantTncActions', 'cancel')
        },
        agreeTnc() {
            var self = this, formData = new FormData();
            formData.append('tnc_accepted', true),
            formData.append('session', true),
            Vue.http.post('/tenant_terms_and_conditions/', formData).then(
                (res) => {
                    if(res.status == 200) {
                        self.$emit('getTenantTncActions', 'accepted')
                    } else {
                        self.$emit('getTenantTncActions', 'error')
                    }
                }, 
                (error) => {
                    console.log("Something went wrong with tenant tnc!", error);
                }
            );
        },
        downloadFile() {
            var element = document.createElement('a');
            // let text = this.title + '\n\n' + document.getElementById('tenantTncText').innerText;
            let text = this.title + '\n\n' + (this.templateData || document.getElementById('tenantTncText').innerText);
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', this.title + '.txt');
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }
}
</script>

<style lang="scss">
.tenantTnc__main-container {
    // width: 600px;
    width: 70%;
    height: auto;
    display: flex;
    margin: auto;

    // Checkbox color & download color
    .theme--light.v-icon {
        color: #C6C7C2;
    }
    
    .tenantTnc__text-container {
        width: 100%;
        color: #EFEFEF;
        font-family: 'Roboto-light';
        font-weight: 600;

        .mainTitle_container {
            text-align: center;
            .v-icon {
                font-size: 2rem;
                // margin-bottom: 16px;
                margin-right: 1rem;
            }
            p {
                font-size: 30px;
            }
        }
        .text_container {
            font-size: 14px;
            max-height: 300px;
            overflow-y: auto;
            .subText__container {
                white-space: pre-line;
            }
            .subText__container.addWidth {
                width: 40%;
                margin: auto;
            }
            .ErrorText {
                display: flex;
                .v-icon {
                    font-size: 2rem;
                    margin-bottom: 16px;
                    margin-right: 1rem;
                }
                p {
                    font-size: 1.5rem;
                }
            }

            .mainPoints {
                margin: 15px;

                ul li::marker {
                    font-size: 1.3rem;
                }
            }
            // checkbox label color
            // .v-input--selection-controls__input+.v-label {
            //     color: #EFEFEF;
            // }

        }
        .main_footer_container {
            .v-input--selection-controls__input+.v-label {
                color: #EFEFEF;
            }
            &.buttons {
                text-align: center;
                .commonButton {
                    background: #E34E25;
                    border-radius: 0;
                    text-transform: uppercase;
                    display: block;
                    margin: auto;
                    width: 10%;
                    font-weight: bold;
                    color: #FFFFFF;
                }
            }
        }

        .sub_footer_container {
            display: flex;
            // margin-top: 24px;
            justify-content: space-between;

            .download {
                margin-top: 22px;
                cursor: pointer;
                color: white;
                margin-right: 24px;
            }
          
            .cancel {
                &.theme--light.v-btn.v-btn--has-bg {
                    background-color: transparent;
                    border: 1px solid #638AFF;
                    font-weight: 600;
                    font-family: 'Roboto-Regular';
                    color: #638AFF;
                    margin-right: 24px;
                }
            }
            .agree {
                &.disable.theme--light.v-btn.v-btn--has-bg {
                    background-color: #5E5D60;
                    color: #98979A;
                    pointer-events: none;
                }
               
                &.enable.theme--light.v-btn.v-btn--has-bg {
                    background-color: #638AFF;
                    pointer-events: all;
                }
            }
            .v-btn {
                margin-top: 8px;
                font-weight: 600;
                height: 48px;
            }
            
            
        }
    }
}
</style>